import { useMemo } from 'react';
import { SWRResponse } from 'swr';
import { GetBusinessCardDataByGuid, GetBusinessCardDataByGuidResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetBusinessCardDataByGuidResponse, GetBusinessCardDataByGuidResponse>) => response?.data?.businessCardData;

export const useBusinessCardByGuid = (guid?: string) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetBusinessCardDataByGuid({guid});
        };
    }, [guid])
    return useGet(request, { getData }, {});

};

export default useBusinessCardByGuid;